<template>
  <div>
    <v-card class="elevation-0">
      <v-card-title>
        <span class="headline" v-if="showHeader">Letter Content</span>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" label="Search Here"></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="items"
          :headers="headers"
          :search="search"
          :footer-props="footerProps"
          :loading="loading"
        >
          <template v-slot:item.withDuration="{ item }">
            <v-checkbox :input-value="item.withDuration" disabled></v-checkbox>
          </template>
          <template v-slot:item.inActiveEmp="{ item }">
            <v-checkbox :input-value="item.inActiveEmp" disabled></v-checkbox>
          </template>
          <template v-slot:item.dateHired="{ item }">
            <v-checkbox :input-value="item.dateHired" disabled></v-checkbox>
          </template>
          <template v-slot:item.dateHiredUpdate="{ item }">
            <v-checkbox
              :input-value="item.dateHiredUpdate"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.dateHiredDelete="{ item }">
            <v-checkbox
              :input-value="item.dateHiredDelete"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.dateRegularized="{ item }">
            <v-checkbox
              :input-value="item.dateRegularized"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.dateRegularizedUpdate="{ item }">
            <v-checkbox
              :input-value="item.dateRegularizedUpdate"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.dateRegularizedDelete="{ item }">
            <v-checkbox
              :input-value="item.dateRegularizedDelete"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.dateRegularizedDelete="{ item }">
            <v-checkbox
              :input-value="item.dateRegularizedDelete"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.endContract="{ item }">
            <v-checkbox :input-value="item.endContract" disabled></v-checkbox>
          </template>
          <template v-slot:item.endContractUpdate="{ item }">
            <v-checkbox
              :input-value="item.endContractUpdate"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.endContractDelete="{ item }">
            <v-checkbox
              :input-value="item.endContractDelete"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.dateResigned="{ item }">
            <v-checkbox :input-value="item.dateResigned" disabled></v-checkbox>
          </template>
          <template v-slot:item.dateResignedUpdate="{ item }">
            <v-checkbox
              :input-value="item.dateResignedUpdate"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.dateResignedDelete="{ item }">
            <v-checkbox
              :input-value="item.dateResignedDelete"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.dateProbationary="{ item }">
            <v-checkbox
              :input-value="item.dateProbationary"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.dateProbationaryUpdate="{ item }">
            <v-checkbox
              :input-value="item.dateProbationaryUpdate"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.dateProbationaryDelete="{ item }">
            <v-checkbox
              :input-value="item.dateProbationaryDelete"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.payrollBit="{ item }">
            <v-checkbox :input-value="item.payrollBit" disabled></v-checkbox>
          </template>
          <template v-slot:item.tksBit="{ item }">
            <v-checkbox :input-value="item.tksBit" disabled></v-checkbox>
          </template>
          <template v-slot:item.hrisBit="{ item }">
            <v-checkbox :input-value="item.hrisBit" disabled></v-checkbox>
          </template>
          <template v-slot:item.activeBit="{ item }">
            <v-checkbox :input-value="item.activeBit" disabled></v-checkbox>
          </template>
          <template v-slot:item.isValidateConsecutivePME="{ item }">
            <v-checkbox
              :input-value="item.isValidateConsecutivePME"
              disabled
            ></v-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <slot name="actions" v-bind:item="item"></slot>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/movementType";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false,
      },
      {
        text: "Code",
        value: "code",
        sortable: true,
      },
      {
        text: "Description",
        value: "description",
        sortable: true,
      },
      {
        text: "With Duration",
        value: "withDuration",
        sortable: false,
      },
      {
        text: "InActive",
        value: "inActiveEmp",
        sortable: false,
      },
      {
        text: "Date Hired",
        value: "dateHired",
        sortable: false,
      },
      {
        text: "Date Hired Update",
        value: "dateHiredUpdate",
        sortable: false,
      },
      {
        text: "Date Hired Delete",
        value: "dateHiredDelete",
        sortable: false,
      },
      {
        text: "Date Regularized",
        value: "dateRegularized",
        sortable: false,
      },
      {
        text: "Date Regularized Update",
        value: "dateRegularizedUpdate",
        sortable: false,
      },
      {
        text: "Date Regularized Delete",
        value: "dateRegularizedDelete",
        sortable: false,
      },
      {
        text: "End Contract",
        value: "endContract",
        sortable: false,
      },
      {
        text: "End Contract Update",
        value: "endContractUpdate",
        sortable: false,
      },
      {
        text: "End Contract Delete",
        value: "endContractDelete",
        sortable: false,
      },
      {
        text: "Date Resigned",
        value: "dateResigned",
        sortable: false,
      },
      {
        text: "Date Resigned Update",
        value: "dateResignedUpdate",
        sortable: false,
      },
      {
        text: "Date Resigned Delete",
        value: "dateResignedDelete",
        sortable: false,
      },
      {
        text: "Date Probationary",
        value: "dateProbationary",
        sortable: false,
      },
      {
        text: "Date Probationary Update",
        value: "dateProbationaryUpdate",
        sortable: false,
      },
      {
        text: "Date Probationary Delete",
        value: "dateProbationaryDelete",
        sortable: false,
      },
      {
        text: "Payroll",
        value: "payrollBit",
        sortable: false,
      },
      {
        text: "TKS",
        value: "tksBit",
        sortable: false,
      },
      {
        text: "HRIS",
        value: "hrisBit",
        sortable: false,
      },
      {
        text: "Active/InActive",
        value: "activeBit",
        sortable: false,
      },
      {
        text: "Enable Validation of Consecutive PME",
        value: "isValidateConsecutivePME",
        sortable: false,
      },
    ],
    loading: false,
    search: "",
    footerProps: {
      rowsPerPageItems: [20, 50],
    },
  }),
  methods: {
    getAll() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          setTimeout(() => {
            this.items = data;
          }, 1000);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
  },
  created() {
    //this.getAll();
  },
  mounted() {
    this.getAll();
  },
};
</script>
<style scoped>
.inactive {
  background-color: rebeccapurple;
}
</style>
